import { gql } from '@apollo/client'

export const ADMIN_AUDIT_FRAGMENT = gql`
  fragment AdminAudit on Audit {
    id
    employee {
      firstName
      lastName
      email
    }
    score {
      soviScores {
        customerCasesCount
        competitorCasesCount
        category
      }
    }
    created
    dateCompleted
    status
    notes
    store {
      id
      name
      category
      address {
        address1
      }
    }
  }
`
